module.exports = __webpack_public_path__ + "button-settings.svg?3a6b9663fb3e808acb89f4677d1b4fb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-settings.svg
// module id = 649
// module chunks = 0